import script from "./LimitRewardTable.vue?vue&type=script&setup=true&lang=js"
export * from "./LimitRewardTable.vue?vue&type=script&setup=true&lang=js"

import "./LimitRewardTable.vue?vue&type=style&index=0&id=042d1b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042d1b22"]])

export default __exports__